module.exports = __webpack_public_path__ + "files/96d293d21e12301fe392ddd0d4dee5c3.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-5.png
// module id = 529
// module chunks = 76